import { ProfileType } from '@/shared/api';
import { useProfileStore } from '@/shared/store/profile.store';

export const useIsFounder = () => {
  const { profileType } = useProfileStore();

  return profileType === ProfileType.MAIN_USER;
};
